export default "__VITE_ASSET__Da0u1WJK__"